import { createAction } from 'redux-act';
import localforage from 'localforage';
import { persistor } from 'components/App/components/UnauthenticatedApp';
import fetch from 'axios';
import { push } from 'connected-react-router';

/**
 * Create action
 */

import completeInitialisation from './initialise';

const request = createAction('LOGOUT_REQUEST');
const error = createAction('LOGOUT_ERROR');
const logout = createAction('USER_LOGOUT');

function logoutUser() {
    return function (dispatch) {
        // Dispatch the request action
        dispatch(request);

        return fetch
            .post(`/api/logout`)
            .then(({ result }) => {
                // Dispatch successa action
                dispatch(logout(result));

                // // Clear the persisted state
                // persistor.purge();
                // persistor.flush();

                return async function () {
                    // Logout the user
                    await dispatch(logout());

                    // Complete the initialisation
                    dispatch(completeInitialisation());
                    dispatch(push('/'));

                    // Clear local storage
                    localforage.clear();
                };
            })
            .catch((err) => {
                dispatch(error(err));
                throw err;
            });
    };
}

export default logoutUser;
export { logout };
